const ImportExportModule = () =>
  import(
    /* webpackChunkName: 'importexportmodule' */ "@/modules/DashboardModule/modules/ImportExportModule/ImportExportModule.vue"
  );
// import { ImportRoutes } from "./modules/ImportModule/routes";
import { ExportRoutes } from "./modules/ExportModule/routes";

export const ImportExportModuleRoutes = [
  {
    path: "",
    component: ImportExportModule,
    children: [...ExportRoutes]
  }
];
